<template>
  <v-text-field
      v-bind="$attrs"
      :value="year_week"
      dense
      outlined
      :clearable="clearable"
      @input="onInput"
      type="week"
      :error="error"
      :error-messages="error_message"
      :hide-details="!property_state_field_name"
  >
  </v-text-field>
</template>

<script>

export default {
  name: 'BaseFieldWeek',
  inheritAttrs: false,
  props: {
    year: {default: null},
    week: {default: null},
    property_state: {default: null},
    property_state_field_name: {default: null},
    clearable: {default: false},
  },

  components: {},

  computed: {
    year_week() {
      return this.year + '-W' + this.week
    },
    error() {
      // console.log('error', this.property_state_field_name)
      return !!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error
    },
    error_message() {
      if (!!!!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error)
        return this.property_state[this.property_state_field_name].error_message
    else
      return null
    },
  },

  methods: {
    onInput(event) {
      // console.log('onInput', event)
      if (event === '') {
        this.$emit('update:year', null)
        this.$emit('update:week', null)
      }
      else {
        let year_week_arr = event.split('-')
        this.$emit('update:year', year_week_arr[0])
        this.$emit('update:week', year_week_arr[1].replace('W', ''))
      }
    },
  },

  async mounted() {
  },

  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
